export function parseJSON (JSONstr) {
  let json = {}

  try {
    json = JSON.parse(JSONstr)
  } catch (e) {
    console.error('Invalid JSON string')
  }

  return json
}
